/** @module                 React */

import { useState }         from "react";

/** @module                 Apollo */

import { useMutation }      from "@apollo/client";

const 

/** 
 * 
 * @returns useCreate hook for creating new mutation
 * 
 */

useCreate = ( MUTATION, mutationOptions = {} ) => { const 

    /** @hooks */

    [ loading,  setLoading  ]       = useState ( false ),

    [ errors,   setErrors   ]       = useState ( null ),

    [ complete, setComplete ]       = useState ( false ),

    [ returnData, setReturnData ]   = useState ( {} ),

    /** @mutations */

    [ CreateEntry ] = useMutation ( MUTATION, {

        /** @event onComplete */

        onCompleted ( data ) {

            setLoading ( false );

            setReturnData ( data );

            setComplete ( true );

        },

        /** @event onError */

        onError ( err ) { setLoading ( false ); setErrors ( err ); }

        ,

        ...mutationOptions

    } ),

    /** 
     * 
     * @param { String } title
     * 
     * @param { String } content
     * 
     * @param { String } description
     * 
     * @param { Boolean } isPublished
     * 
     * @param { Boolean } tiremarketOnly
     * 
     * @param { String } language
     * 
     * @returns create post action
     * 
     */

    createMutation = ( data ) => {

        /** @override hook states */

        setErrors ( null ); setLoading ( true ); 

        /** @mutation */

        CreateEntry ( { variables: data } );

    }

    /** @returns */

    return { createMutation, loading, complete, returnData, errors, setErrors }

};

/** @exports useCreate */

export default useCreate;